import { TextField, TextFieldProps } from '@mui/material'
import { FormattedMessage, useIntl } from 'react-intl'
import { Control, Controller, DeepMap, FieldError } from 'react-hook-form'
import get from 'lodash/get'

export type TextInputProps = TextFieldProps & {
  name: string
  intlKey?: string
  control?: Control<any, object>
  errors?: DeepMap<any, FieldError>
  fullWidth?: boolean
  readOnly?: boolean
}

export function TextInput({
  name,
  intlKey,
  defaultValue,
  control,
  fullWidth = true,
  errors,
  readOnly,
  InputProps,
  ...props
}: TextInputProps) {
  const intl = useIntl()
  const translatedName = name ? intl.formatMessage({ id: intlKey ?? name }) : ''
  const fieldError = get(errors, name)

  return control ? (
    <Controller
      name={name}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <TextField
          {...props}
          {...field}
          fullWidth={fullWidth}
          InputProps={{
            style: {
              backgroundColor: '#fff',
              color: readOnly ? 'rgba(0, 0, 0, 0.38)' : 'black',
              borderRadius: 6,
            },
            readOnly,
            ...InputProps,
          }}
          name={name && translatedName}
          label={name && translatedName}
          placeholder={name && translatedName}
          error={!!fieldError}
          helperText={
            !!fieldError && <FormattedMessage id={fieldError.message} />
          }
        />
      )}
    />
  ) : (
    <TextField
      {...props}
      fullWidth={fullWidth}
      InputProps={{
        style: {
          backgroundColor: '#fff',
          color: readOnly ? 'rgba(0, 0, 0, 0.38)' : 'black',
        },
        readOnly,
        ...InputProps,
      }}
      name={name && translatedName}
      label={name && translatedName}
      placeholder={name && translatedName}
      error={!!fieldError}
      helperText={!!fieldError && <FormattedMessage id={fieldError.message} />}
    />
  )
}
